import styled from 'styled-components';

export default styled.ol`

  padding-left: ${props => props.fontSize || '1em'};

  & ::marker {
    color: ${props => props.color};
    font-size: ${props => props.fontSize};
  }
`;

